import { TypedForm } from '@bo-client/shared/forms/generic-forms/typedForm.type';

export class ConnectionObjectAdditionalInfoModel {
  //additional objectaddress info
  isNewBuilding?: boolean;
  buildingType?: number;
  numberOfFlats?: number;
  numberOfUsers?: number;
  numberOfOtherUsers?: number;
  objectUsage?: string;
}

export type ConnectionObjectAdditionalInfoForm = TypedForm<ConnectionObjectAdditionalInfoModel>;
